module.exports = __webpack_public_path__ + "static/tooltip-bold-do-b6c7bd9c3c2f3f49a534c4df13c92d54.png";